import { Image } from '../../multimedia/GridOfPhotos/types';
import { ImageData } from '../ResumeLoadImages/types';

/**
 * Campos extra que el objeto real de `GET_IMAGE_BY_ID` trae en runtime pero
 * que el tipo estrecho `ImageData` (usado por el loader del resumen) no declara.
 * El adapter los lee de forma controlada para construir el shape `Image` que
 * espera `GridOfPhotos`.
 */
type LoaderImage = ImageData & {
  cloudinaryPublicId?: string | null;
  storageKey?: string | null;
  storageProvider?: string | null;
  publicUrl?: string | null;
  orderIDs?: string[];
  capture?: Image['capture'];
};

/**
 * Adapta las imágenes que entrega el loader del resumen de actuación al shape
 * `Image` de `GridOfPhotos`. Inyecta el `roid` de la actuación porque `Image`
 * lo necesita para el nombre de descarga y los metadatos del modal ampliado.
 */
export function mapToGridImages(
  images: ImageData[] | undefined,
  roid: string,
): Image[] {
  return (images ?? []).map((img) => {
    const raw = img as LoaderImage;
    return {
      id: raw.id,
      name: raw.name,
      creatingDate: raw.creatingDate,
      cloudinaryPublicId: raw.cloudinaryPublicId ?? null,
      storageKey: raw.storageKey ?? null,
      storageProvider: raw.storageProvider ?? null,
      publicUrl: raw.publicUrl ?? null,
      orderIDs: raw.orderIDs ?? [],
      roid,
      // 🔴 Un adaptador que elige campos a mano los pierde en silencio (pasó
      // con `publicUrl`): el visor necesita `capture` para no releer el
      // original (spec fotos geolocalizadas § 18).
      ...(raw.capture !== undefined ? { capture: raw.capture } : {}),
    };
  });
}
